import * as React from 'react';
import { Col } from 'reactstrap';
import { TranslationFunction } from 'i18next';
import {
  FieldEmail,
  FieldPhone,
  FieldList,
  Title
} from '../../ui/DataDisplay/FieldList/FieldList';
import Row from 'reactstrap/lib/Row';

import { translate } from 'react-i18next';
import { inject, observer } from 'mobx-react';
import { Store } from '../../stores';
interface IProps {
  t: TranslationFunction;
  Store?: Store;
}

const TechnicalSupport = inject('Store')(
  observer(({ t, Store: mobix }: IProps) => {
    const { country } = mobix!.profile;
    return (
      <Col className="technical-support mobile-helper" xs={12}>
        <FieldList>
          <Title text={t('technicalTitle')} />

          {country !== 'CH' && (
            <FieldPhone
              name={t('france')}
              phone={t('franceTechnicalSupportNumber')}
            />
          )}
          {country !== 'FR' && (
            <FieldPhone
              name={t('switzerland')}
              phone={t('switzerlandTechnicalSupportNumber')}
            />
          )}
          <FieldEmail name={t('email')} email={t('supportTechnicalEmail')} />
        </FieldList>
      </Col>
    );
  })
);

export default translate('Support')(TechnicalSupport);
